import { Tooltip } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { CellRendererParams } from '../types';

export const MarkedTooltip: FC<{ isMarked?: boolean }> = ({
  isMarked,
  children,
}) => {
  if (!isMarked) {
    return <>{children}</>;
  }

  return (
    <Tooltip title={<FormattedMessage id="timesheets.events.already-added" />}>
      {children}
    </Tooltip>
  );
};

export const SelectionTooltip: FC<AtLeast<CellRendererParams, 'data'>> = ({
  data,
  children,
}) => {
  const { projects, marked } = data;

  if (projects && !marked) {
    return <>{children}</>;
  }
  if (!projects) {
    return <>{children}</>;
  }

  return (
    <Tooltip
      title={
        <FormattedMessage
          id={
            marked
              ? 'timesheets.events.already-added'
              : 'timesheets.events.project-missing'
          }
        />
      }
    >
      {children}
    </Tooltip>
  );
};
